import {Box} from 'src/design/atoms/Box';
import {Stack} from 'src/design/atoms/Stack';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {Button} from 'src/design/atoms/Button';
import {Title} from 'src/design/atoms/Title';
import {PageSkeleton} from 'src/design/atoms/PageSkeleton';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const documentTitle = 'Feature Not Quite Ready Yet';

const UnderConstructionPage = () => {
  useSetDocumentTitle(documentTitle);

  return (
    <Stack mt="md" gap="md">
      <Title>
        This feature is still in developement. It will be ready soon!
      </Title>

      <PageSkeleton width="70%" />

      <Box>
        <Button
          aria-label="backToDashboardBtnUI"
          size="lg"
          mt="md"
          onClick={() => window.location.assign(PathUtility.Dashboard())}>
          Back to Dashboard
        </Button>
      </Box>
    </Stack>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.UnderConstruction(),
  element: <UnderConstructionPage />,
  isPrivate: false,
});

export default UnderConstructionPage;
